module.exports = __webpack_public_path__ + "img/password.5b998735.png";